import { Icon } from '@/shared/ui'

export const PlaceholderThumbnail = () => {
  return (
    <div className="flex items-center justify-center rounded-full bg-gray-50 px-1.5 pt-1 pb-2 transition-colors duration-300 group-hover:bg-gray-100">
      <Icon name="home" width={20} height={20} className="text-gray-500" />
    </div>
  )
}
